import { IConfigurationModel, RouteHelper } from "@nf/common";
import { ROUTES } from "@nf/constants";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { buildLocalizedUrl } from "helpers";
import { useCountry, useLanguage, useIsAuthenticated } from "hooks";

import AppFooterMobileButton from "./AppFooterMobileButton";

import Home from "resources/icons/home.svg";
import Search from "resources/icons/search.svg";
import Burger from "resources/icons/menu.svg";

import styles from "./AppFooterMobile.module.scss";

export type AppFooterProps = {
  configuration?: IConfigurationModel;
};

export const AppFooterMobile = () => {
  const { t } = useTranslation("translations");
  const { isLoggedIn, isChild } = useIsAuthenticated();
  const router = useRouter();
  const country = useCountry();
  const language = useLanguage();

  const getIsActive = (path: string) =>
    router.asPath.includes(
      buildLocalizedUrl(path, country, language).toString()
    );

  return (
    <div className={styles.footer}>
      <div className={styles.gradient} />

      <AppFooterMobileButton
        icon={<Home />}
        href={RouteHelper.goToHome()}
        isActive={getIsActive(RouteHelper.goToHome())}
      >
        {t("web_menu_home")}
      </AppFooterMobileButton>

      <AppFooterMobileButton
        icon={<Search />}
        href={RouteHelper.goToSearch()}
        isActive={getIsActive(RouteHelper.goToSearch())}
      >
        {t("web_menu_search")}
      </AppFooterMobileButton>

      {isLoggedIn && !isChild && (
        <AppFooterMobileButton
          icon={<Burger />}
          href={RouteHelper.goToSettings()}
          isActive={getIsActive(RouteHelper.goToSettings())}
        >
          {t("web_menu")}
        </AppFooterMobileButton>
      )}

      {!isLoggedIn && (
        <AppFooterMobileButton icon={<Burger />} href={ROUTES.LOGIN}>
          {t("web_menu")}
        </AppFooterMobileButton>
      )}
    </div>
  );
};

export default AppFooterMobile;
